import { useQueryClient } from '@tanstack/react-query';
import { getMissingApprovals } from 'lib/api/approvals';
import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import SharedApprovalPage from 'pages/mobile/Finance/shared/ApprovalPage';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

interface ApprovalLocationState {
  type: 'approve' | 'reject';
  requestId?: number;
  userRoles?: Array<{ id: number; name: string }>;
}

const ConfirmingApproval: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const state = location.state as ApprovalLocationState | undefined;
  const requestIdNum =
    state?.requestId ?? (id != null && id !== '' ? Number(id) : 0);

  const { data: missingApprovals } = getMissingApprovals(
    dispatch,
    APPROVAL_TYPES.CONFIRMING,
    requestIdNum,
    COMITEE_TYPES.RISK,
  );

  const userRolesFromState = state?.userRoles;
  const userRolesFromApi = useMemo(() => {
    if (!missingApprovals?.roles) return [];
    return missingApprovals.roles
      .filter((r) => r.userCanApprove)
      .map((r) => ({ id: r.roleId, name: r.roleName }));
  }, [missingApprovals?.roles]);
  const userRoles = userRolesFromState ?? userRolesFromApi;

  const onSuccess = () => {
    if (id) {
      void queryClient.invalidateQueries({
        queryKey: ['confirming', 'request', id, 'overview'],
      });
    }
    navigate(-1);
  };

  return (
    <SharedApprovalPage
      approvalType={APPROVAL_TYPES.CONFIRMING}
      entityId={requestIdNum}
      requestId={id ?? ''}
      userRoles={userRoles}
      onSuccess={onSuccess}
      isError={!id || requestIdNum <= 0}
    />
  );
};

export default ConfirmingApproval;
